<template>
    <div class="slider-box">
        <h5>How much Chlorine did you add?</h5>
        <w-button class="px-3 d-block mx-auto" @click="update()">Update</w-button>
        <small class="text-danger" v-if="error">{{error}}</small>
        <div class="line">
            <div></div>
        </div>
        <div class="row">
            <div class="col-5">
                <div class="line-label" v-for="i in 17" :key="i">
                    <template v-if="!(((17 - i) / 4) % 1)">
                        <span @click="value = (17 - i) / 4" v-if="i === 1" class="right cursor-pointer text-blue">Filled it up</span>
                        <span @click="value = (17 - i) / 4" v-else-if="i === 17" class="right cursor-pointer">0.0</span>
                        <span @click="value = (17 - i) / 4" v-else class="cursor-pointer right">{{(17 - i) / 4}} Bags</span>
                    </template>
                </div>
            </div>
            <div class="col-2">
                <span class="rounded-circle cursor-pointer" @click="value = 4"></span>
                <custom-range v-model="value" :min="0" :max="4" :step="0.25"></custom-range>
            </div>
            <div class="col-5">
                <div class="line-label" v-for="i in 17" :key="i">
                    <span @click="value = (17 - i) / 4" class="cursor-pointer left" v-if="((17 - i) / 4) <= 3">-</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomRange from './CustomRange'
import { mapGetters } from 'vuex'
import { lambda } from '@/amplify'
export default {
    name: 'Chlorine',
    props: ['podId'],
    data () {
        return {
            value: 0,
            error: null
        }
    },
    methods: {
        update () {
            lambda('managePod', {
                podId: this.pool.pods[0].podId,
                refillableReq: {
                    clBagsAdded: this.value > 3 ? 3 : this.value,
                    ...(this.value > 3 && { clPctLeft: 100 })
                }
            }).then(data => {
                if (data.code === 'OK') this.$emit('update')
                else this.error = 'Something went wrong'
            }).catch(err => {
                this.error = err.message || 'Something went wrong'
            })
        }
    },
    computed: {
        ...mapGetters({
            pool: 'pools/pool'
        })
    },
    components: { CustomRange },
    watch: {
        value (val, old) {
            if (parseFloat(val) > 3 && parseFloat(val) < 4) this.value = val < old ? 3 : 4
        }
    }
}
</script>

<style scoped>
    h5 {
        font-weight: 300;
    }

    @media (max-width: 576px) {
        h5 {
            margin-left: -15px;
            margin-right: -15px;
            font-size: 17px;
            margin-bottom: 15px;
        }
    }

    .middle > span {
        line-height: 38px;
    }

    .slider-box div.line {
        position: relative;
        width: 250px;
        top: 50px;
        margin: 0;
        z-index: 2;
        padding: 3px;
        background-color: #fff;
    }

    .slider-box div.line div {
        background-color: #d1d1d1;
        height: 2px;
        z-index: 3;
        width: 100%;
    }

    .text-blue {
        color: #47a4cb;
    }

    .line-label .text-blue {
        position: absolute;
        top: 0;
    }

    .rounded-circle {
        background-color: #fff;
        z-index: 1;
        width: 1.5em;
        height: 1.5em;
        position: absolute;
        border: 1px solid #ccc;
        left: 5px;
    }
</style>
